import { RouteComponentProps } from 'react-router-dom';
import qs from 'query-string';
import { AppDispatch } from 'src/store';
import { IQueryParams } from 'src/types';
import { removeEmpty } from 'src/utils/removeEmpty';
import { createAction } from '@reduxjs/toolkit';

import { createHintRequest, fetchHintsPageRequest, updateHintRequest } from './requestHandlers';
import { IHint, IHintListData } from './types';

const defaultParams = {
  page: '0',
  size: '10',
};

export const loadHintsStart = createAction('hints/load/start');
export const loadHintsSuccess = createAction<IHintListData>('hints/load/success');

export const fetchHintsPage = (history: RouteComponentProps['history'], params: IQueryParams = {}, type?: string) => {
  return async (dispatch: AppDispatch): Promise<boolean> => {
    dispatch(loadHintsStart());
    const initialParams = qs.parse(history.location.search);
    const mergedParams = type === 'reset' ? defaultParams : removeEmpty({ ...defaultParams, ...initialParams, ...params });
    const data = await fetchHintsPageRequest(mergedParams);
    if (data) {
      dispatch(loadHintsSuccess(data));
    }
    history.replace({
      search: qs.stringify(mergedParams, { skipNull: true }),
    });
    return true;
  };
};

export const createHint = async (data: Partial<IHint>): Promise<Partial<IHint>> => createHintRequest(data);

export const updateHint = async (data: Partial<IHint>): Promise<Partial<IHint>> => updateHintRequest(data);
